import { render, staticRenderFns } from "./markDialog.vue?vue&type=template&id=54f5fff8&scoped=true"
import script from "./markDialog.vue?vue&type=script&lang=js"
export * from "./markDialog.vue?vue&type=script&lang=js"
import style0 from "./markDialog.vue?vue&type=style&index=0&id=54f5fff8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5fff8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f5fff8')) {
      api.createRecord('54f5fff8', component.options)
    } else {
      api.reload('54f5fff8', component.options)
    }
    module.hot.accept("./markDialog.vue?vue&type=template&id=54f5fff8&scoped=true", function () {
      api.rerender('54f5fff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/components/markDialog.vue"
export default component.exports